<template>
  <div class="app-content">
    <!-- <h2 v-if="title" class="app-content__title">{{ title }}</h2> -->
    <div class="app-content__body">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import { activeModules } from "@/router/module-loader";

export default {
  name: "AppContent",
  computed: {
    // "모듈명 > 메뉴 타이틀" (모듈명은 meta.perm=appCode 로 매칭)
    title() {
      const meta = this.$route.meta || {};
      const menu = meta.title || "";
      const mod = activeModules.find((m) => m.appCode === meta.perm);
      const modName = mod?.nav?.name || mod?.name || "";
      return modName && menu ? `${modName} > ${menu}` : menu;
    },
  },
};
</script>

<style scoped>
.app-content {
  height: 100%;
  box-sizing: border-box;
  /* 좌우 여백 = AR Remote 원본 반응형에서 20% 축소 */
  padding: 20px 0.8rem;
  display: flex;
  flex-direction: column;
}
@media (min-width: 640px) {
  .app-content {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }
}
@media (min-width: 768px) {
  .app-content {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 1024px) {
  .app-content {
    padding-left: 8rem;
    padding-right: 8rem;
  }
}
/* 콘텐츠 폭 = 좌우 여백(app-content padding) 안쪽 100%. 별도 max-width 캡 없음(단일 소스). */
.app-content__title,
.app-content__body {
  width: 100%;
}
.app-content__title {
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 16px;
  flex: 0 0 auto;
}
.app-content__body {
  flex: 1 1 auto;
  min-height: 0; /* flex 자식이 넘칠 때 스크롤이 여기서만 생기도록 */
  /* 세로만 스크롤(바는 숨김). 가로는 클램프 — 대시보드 등에서 창 좁힐 때 가로 스크롤바 방지.
     가로 스크롤이 필요한 넓은 콘텐츠(채팅 피드·로그 JSON 등)는 자체 overflow-x-auto 래퍼로 처리됨. */
  overflow-x: hidden;
  overflow-y: auto;
  /* 스크롤 기능은 유지하되 스크롤바만 숨김 (사이드네비/회원가입과 동일 처리) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.app-content__body::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
